import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AuthContext } from '@app/providers';

export function PrivateRoute({ children, ...rest }: any) {
  const { userInfo } = useContext(AuthContext);
  const emailVerified =
    userInfo &&
    userInfo.emailVerification &&
    userInfo.emailVerification.completed;

  return (
    <Route
      {...rest}
      render={({ location }) =>
        emailVerified ? (
          children
        ) : userInfo ? (
          <Redirect
            to={{
              pathname: '/email-verify',
              state: { from: location },
            }}
          />
        ) : (
          <Redirect
            to={{
              pathname: '/sign-in',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}
